export enum RSVPType {
  WATCH_PARTY = 'WATCH_PARTY',
  BULK_PURCHASE_TRANSACTION = 'BULK_PURCHASE_TRANSACTION'
}

export enum RSVPStatus {
  UNKNOWN = "UNKNOWN",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED"
}

export interface IRsvpDetails {
  id: string;
  hostId: number;
  participantId: number;
  status: RSVPStatus;
  customId: string;
  customIdType: RSVPType;
  metadata: Record<string, any>;
}
